import PathsConfig from "./RoutePaths";

export const notFoundConfig = {
    path: PathsConfig.HomeMyAccount,
    delayToRedirect: 30000
}